import React from 'react';

function Index({buttontype,text}){
    return(
            <button className={`button ${buttontype}`}>{text}
                <i className="fas fa-long-arrow-alt-right ml-1"></i>
             </button>
    );
}
export default Index